import { render } from "./ManufMethodMgmt.vue?vue&type=template&id=23a9a20b&scoped=true&ts=true"
import script from "./ManufMethodMgmt.vue?vue&type=script&lang=ts"
export * from "./ManufMethodMgmt.vue?vue&type=script&lang=ts"

import "./ManufMethodMgmt.vue?vue&type=style&index=0&id=23a9a20b&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a9a20b"]])

export default __exports__